"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DueDateFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const dates_1 = require("../../type-checking/dates");
const get_value_1 = require("./get-value");
const objects_1 = require("../../type-checking/objects");
const primitives_1 = require("../../type-checking/primitives");
const typing_1 = require("../../type-checking/typing");
const string_1 = require("../../type-checking/string");
const get_value_2 = require("../date-field/get-value");
class DueDateFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                from_date: (0, typing_1.Optional)(dates_1.isDateValue),
                to_date: (0, typing_1.Optional)(dates_1.isDateValue),
                status_is_completed: (0, typing_1.Optional)(primitives_1.isBooleanValue),
                status_updated_on: (0, typing_1.Optional)(string_1.isNullableStringValue),
                is_overdue: (0, typing_1.Optional)(primitives_1.isBooleanValue),
                repeating_task: (0, typing_1.Optional)(objects_1.isNullableObjectLikeValue),
            });
        };
        this.getEmptyValue = () => (0, get_value_1.getDueDateFieldEmptyValue)();
        this.isOptimizedFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                from_date: (0, typing_1.Optional)(dates_1.isDateAsStringValue),
                to_date: dates_1.isDateAsStringValue,
                overdue: (0, typing_1.Optional)(primitives_1.isOptimizedTrueValue),
                completed: (0, typing_1.Optional)(primitives_1.isOptimizedTrueValue),
                updated: (0, typing_1.Optional)(string_1.isNullableStringValue),
                repeating: (0, typing_1.Optional)(objects_1.isNullableObjectLikeValue),
            }, true);
        };
        this.getValueFromOptimized = (fieldValue) => {
            var _a;
            const emptyDateValue = {
                date: null,
                include_time: false,
            };
            const valueFromOptimized = {
                from_date: fieldValue.from_date
                    ? (0, get_value_2.getDateValueFromOptimized)(fieldValue.from_date)
                    : emptyDateValue,
                to_date: fieldValue.to_date
                    ? (0, get_value_2.getDateValueFromOptimized)(fieldValue.to_date)
                    : emptyDateValue,
                status_updated_on: (_a = fieldValue.updated) !== null && _a !== void 0 ? _a : null,
                status_is_completed: !!fieldValue.completed,
            };
            if (fieldValue.overdue) {
                valueFromOptimized.is_overdue = true;
            }
            if (fieldValue.repeating) {
                valueFromOptimized.repeating_task = fieldValue.repeating;
            }
            return valueFromOptimized;
        };
    }
}
exports.DueDateFieldValueGetter = DueDateFieldValueGetter;
